export default __webpack_public_path__ + "8415da41982d05836e83dd0c0b9453b1.png";